/**
 * Query key factory for sessions-related queries
 */
export const sessionsKeys = {
    all: ["sessions"] as const,
    attendance: {
        all: () => [...sessionsKeys.all, "attendance"] as const,
        session: (sessionId: string) => [...sessionsKeys.attendance.all(), sessionId] as const,
    },
    books: {
        all: () => [...sessionsKeys.all, "books"] as const,
        detail: (bookId: string) => [...sessionsKeys.books.all(), bookId] as const,
        stats: (bookId: string) => [...sessionsKeys.books.all(), bookId, "stats"] as const,
    },
    sessions: {
        all: () => [...sessionsKeys.all, "sessions"] as const,
        byBook: (bookId: string) => [...sessionsKeys.sessions.all(), "book", bookId] as const,
        detail: (sessionId: string) => [...sessionsKeys.sessions.all(), "detail", sessionId] as const,
        month: (year: number, month: number) => [...sessionsKeys.sessions.all(), year, month] as const,
    },
    venues: {
        all: () => [...sessionsKeys.all, "venues"] as const,
        detail: (venueId: string) => [...sessionsKeys.venues.all(), venueId] as const,
    },
};
